import React from 'react'
import { GridColumn } from 'src/components/Reusable/Grid'
import { ControlComplianceStatsComponent } from '../../../components/async/model/stats'

type Props = {
  controlId: string
  type: 'automated' | 'manual'
}

export const EvidenceCounts = (props: Props): JSX.Element => {
  return (
    <ControlComplianceStatsComponent
      {...props}
      child={({ stats }) => (
        <GridColumn>
          {props.type === 'automated'
            ? stats.getAutomatedEvidenceCount()
            : stats.getManualEvidenceCount()}
        </GridColumn>
      )}
      onError={() => <p>-</p>}
    />
  )
}
